import Vue from "vue/dist/vue.min.js";

window.Vue = Vue;
